module.exports = __webpack_public_path__ + "img/iPhone6_sml-95016c2248d446e8ca695ea84f831dfe.png";